module.exports = __webpack_public_path__ + "static/media/info-alt.cad49a36.svg";